module.exports = __webpack_public_path__ + "img/close-circle.92298e7d.svg";